import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useUpdateProductOffsets = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Parameters<typeof apiClient.updatePricingPlanProductsOffset>[0]) => {
      await apiClient.updatePricingPlanProductsOffset(vars);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [{ endpoint: "/api/data_report/product_report" }],
      });
    },
  });
};
